import { Chip } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { getChipSxStylingForLevel } from 'styles/utils';
import { CostConfigStatus } from 'components/profitability/configQueryHooks';
import { Button } from 'components/Button';
import { Tile } from 'components/Layout/PageContainer';
import { formatCostConfigurationDate } from '../formatCostConfigurationDate';

interface CostTypeCardProps {
  titleId?: string;
  title?: string;
  status: CostConfigStatus;
  statusDate?: Date;
  onDownload?: () => void;
  testId?: string;
}

function StatusBadge({ status }: { status: CostConfigStatus }) {
  switch (status) {
    case 'SCHEDULED':
      return (
        <Chip
          size="small"
          sx={getChipSxStylingForLevel('Warning')}
          label={<FormattedMessage id="profitability.cost-configurations.badge.scheduled" />}
        />
      );
    case 'UPDATED':
      return (
        <Chip
          size="small"
          sx={getChipSxStylingForLevel('Information')}
          label={<FormattedMessage id="profitability.cost-configurations.badge.custom" />}
        />
      );
    default:
      return (
        <Chip
          size="small"
          sx={getChipSxStylingForLevel('Neutral')}
          label={<FormattedMessage id="profitability.cost-configurations.badge.none" />}
        />
      );
  }
}

export function CostTypeCard({
  titleId = undefined,
  title = undefined,
  status,
  statusDate = undefined,
  onDownload = undefined,
  testId = 'cost-type-card',
}: CostTypeCardProps) {
  const intl = useIntl();

  return (
    <Tile
      className="pb-6 pt-2.5 pl-8"
      testId={testId}
      title={title}
      titleId={titleId}
      rightHandTitleComponent={
        <div className="self-start justify-self-end">
          <Button icon="Download" aria-label="download" data-testid={`${testId}-download`} onClick={onDownload} />
        </div>
      }
      additionalTitle={<StatusBadge status={status} />}
      subtitle={
        status === 'NONE' ? null : (
          <FormattedMessage
            id={
              status === 'SCHEDULED'
                ? 'profitability.cost-configurations.card.effectiveFrom'
                : 'profitability.cost-configurations.card.updatedOn'
            }
            values={{
              date: statusDate ? formatCostConfigurationDate(intl, statusDate) : '',
            }}
          />
        )
      }
    />
  );
}
